import CardSystem from '../CardSystem';
import GameObject from '../../../GameObject/GameObject';
import Animator from '../../../Prototype/Animator';
import { ICardStateTaskData } from '../../../State/Card/ICardState';
import { RenderSystemEvent } from 'System/Render/RenderSystem';
import { AnimationClipTask } from 'Utility/Task/AnimationClipTask';
import { RevealCanisterPreBooster } from '../../Animation/Clip/RevealCanisterPreBooster';
import { UIEvent } from 'System/UI/BaseUISystem';
import BaseCard from 'Prototype/Level/Card/BaseCard';
import Renderable from '../../../Component/Renderable';

export default function RevealCanisterPreBoosterAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData,
): void {
    system.scene.emit(UIEvent.DISABLE_INTERACTIVITY, false);

    const animator = GameObject.Instantiate(Animator);
    system.animator.addChild(animator);
    system.scene.emit(RenderSystemEvent.BRING_TO_FRONT, system.animator);
    const card: BaseCard = system.getCardByID(taskData.cards[0]);
    card.getComponent(Renderable).visible = false;

    system.taskQueue.queue(
        new AnimationClipTask(
            new RevealCanisterPreBooster(animator, {
                system,
                card,
                cardId: taskData.cards[0],
            })
        )
    );
}
